package com.wintermar.inspection.core.ui.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_check
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

@Composable
fun SelectableItem(
    selected: Boolean,
    text: String,
    backgroundColor: Color,
    badgeColor: Color,
    borderColor: Color,
    textColor: Color,
    onClick: () -> Unit
) {
    val scale = remember { Animatable(initialValue = 1f) }
    val color = LocalAppTheme.current.color

    LaunchedEffect(key1 = selected) {
        if (selected) {
            val job = launch {
                scale.animateTo(
                    targetValue = 0.95f, animationSpec = tween(
                        durationMillis = 50
                    )
                )
                scale.animateTo(
                    targetValue = 1f, animationSpec = spring(
                        dampingRatio = Spring.DampingRatioLowBouncy, stiffness = Spring.StiffnessLow
                    )
                )
            }
            job.join()
        }
    }

    Box {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(
                space = LocalAppTheme.current.dimension.spacing.space2,
                alignment = Alignment.CenterHorizontally
            ),
            modifier = Modifier.scale(scale = scale.value)
                .fillMaxWidth()
                .border(
                    border = BorderStroke(
                        width = 1.dp,
                        color = if (selected) borderColor else color.border.default
                    ), shape = RoundedCornerShape(LocalAppTheme.current.dimension.spacing.space2)
                )
                .background(
                    color = if (selected) backgroundColor else color.bg.normal,
                    shape = RoundedCornerShape(LocalAppTheme.current.dimension.spacing.space2)
                )
                .clip(RoundedCornerShape(LocalAppTheme.current.dimension.spacing.space2))
                .clickable {
                    onClick()
                }
                .padding(
                    horizontal = LocalAppTheme.current.dimension.spacing.space3,
                    vertical = LocalAppTheme.current.dimension.spacing.space2
                ),
        ) {
            TextBodySmall(
                text = text,
                color = { if (selected) textColor else it.default },
                bold = true
            )
        }
        AnimatedVisibility(
            visible = selected,
            enter = fadeIn() + scaleIn(tween(durationMillis = 400)),
            exit = fadeOut() + scaleOut(),

            ) {
            Box(
                modifier = Modifier.size(20.dp).background(
                    color = badgeColor,
                    shape = RoundedCornerShape(bottomEnd = 8.dp, topStart = 8.dp)
                ), contentAlignment = Alignment.TopStart
            ) {
                Icon(
                    painter = painterResource(Res.drawable.ic_check),
                    tint = LocalAppTheme.current.color.icon.inverse,
                    modifier = Modifier.align(Alignment.Center).size(12.dp),
                    contentDescription = null
                )
            }
        }
    }
}
